import React from 'react';
import errorImage from '../img/not-found.svg';


// Importing Style
import './App.css';

function PageError404() {
  let urlEmpty = '';
  return(
    <React.Fragment>
      <div className="niceadmin">
        <main>
          <div className="container">

            <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
              <h1>404</h1>
              <h2>The page you are looking for doesn't exist.</h2>
              <a className="btn" href={window.location.origin}><span>Back to home</span></a>
              <img src={errorImage} className="img-fluid py-5" alt="Page Not Found" />
              <div className="credits">
                
              </div>
            </section>

          </div>
        </main>
      </div>
    </React.Fragment>
  );
}

export default PageError404;